import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { B as Button } from '../../Button/Button-BzSULnj6.js';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { p as download } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const InternalButton = withTaktFallbackId(Button);
const TriggerButton = ({
  label,
  hideLabel = false,
  icon = download,
  taktFallbackId,
  ...props
}) => /*#__PURE__*/React__default.createElement(InternalButton, _extends({}, props, {
  "aria-label": hideLabel ? label : undefined,
  iconStart: icon,
  taktFallbackId: taktFallbackId
}), !hideLabel && label);

export { TriggerButton as T };
//# sourceMappingURL=TriggerButton-wZRwkl_w.js.map
